// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Youtube: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 46 34" enableBackground="new 0 0 46 34" xmlSpace="preserve">
	<g fill="currentColor">
		<path fillRule="evenodd" clipRule="evenodd" d="M39.12,0H6.88C3.08,0,0,3.25,0,7.26v19.48C0,30.75,3.08,34,6.88,34h32.25
		c3.8,0,6.88-3.25,6.88-7.26V7.26C46,3.25,42.92,0,39.12,0z M18.4,25.22V6.92l13.14,9.14L18.4,25.22z"/>
	</g>
</svg>;
};

export default React.memo(Youtube);
